import { proxy, useSnapshot } from 'valtio';

type ReleaseChartsState = {
  /*
   * Keep track of which chart is expanded
   * So we can show the opened accordion when users navigate back to the page
   * and the chart is still expanded
   */
  expandedId: string | null;
};

const initialState: ReleaseChartsState = {
  expandedId: null,
};

// Keep track of state per release
export const releaseChartsState: ReleaseChartsState = proxy(initialState);

export const useReleaseChartsState = () => useSnapshot(releaseChartsState);
